import http from "../../http";

const column = {
    // 获取社区栏目平铺数据
    selectLayerByOrgCode(r) {
        return  http.spin.get("/gateway/api/symanage/pc/columnTree/selectLayerByOrgCode",r )
    },
}
export default column
